import classNames from "classnames";
import * as React from "react";
import { useSelector } from "react-redux";
import { getEmailOnlyMentions } from "~/messageBoard";
import { messageBoardResx } from "~/resxDist/messageBoardResx";
import { Mention } from "~/sharedComponents/advancedEditor/types/types";
import { ProjectOrTask, RootMessageBoardState } from "../types";
import * as styles from "./MentionComponent.less";

export type MentionComponentProps = {
    mention: Mention;
    children: React.ReactChild;
    request: ProjectOrTask;
};

const MentionComponent = ({ mention, children, request }: MentionComponentProps) => {
    const currentUserId = ep.settings.currentUserId;
    const yourself = mention.id === currentUserId || mention.users?.includes(currentUserId);
    const emailOnlyMentions = useSelector<RootMessageBoardState, Dictionary<boolean>>(state =>
        getEmailOnlyMentions(state, request)
    );
    const isEmailOnlyMention = emailOnlyMentions[mention.id];
    const combinedClassName = classNames(
        styles.highlight_mention,
        "fs-block",
        yourself && styles.yourself,
        isEmailOnlyMention && styles.email_only
    );

    return (
        <>
            {isEmailOnlyMention && (
                <span
                    className={styles.email_only_prefix}
                    title={messageBoardResx.email_only_mention_title}
                    contentEditable={false}
                >
                    Email
                </span>
            )}
            <span
                className={combinedClassName}
                spellCheck={false}
                title={isEmailOnlyMention && messageBoardResx.email_only_mention_title}
            >
                {children}
            </span>
        </>
    );
};

export const createMentionComponent = (request: ProjectOrTask) => (props: MentionComponentProps) =>
    <MentionComponent {...props} request={request} />;

export const internal = { MentionComponent };
